import { spacingFn } from '@britishcouncil/react-extro-ui';
import styled from '@emotion/styled';

export const Root = styled.div<{ withContent?: boolean }>`
  min-height: ${({ theme, withContent }) => (withContent ? spacingFn(10) : theme.spacing.lg)};
  display: flex;
  align-items: center;
`;
